import { z } from 'zod';
import { VariantJSONSchema } from './variant';

export const FlagJSONSchema = z.object({
	createdAt: z.iso.datetime(),
	description: z.string().min(1),
	enabled: z.boolean(),
	expiresAt: z.iso.datetime(),
	id: z.string().min(1),
	service: z.string().min(1),
	variants: z.array(VariantJSONSchema),
});

export type IFlagJSON = z.infer<typeof FlagJSONSchema>;
